type ActivityListener = (count: number) => void;

const listeners = new Set<ActivityListener>();
let activeRequestCount = 0;

const notifyListeners = () => {
	listeners.forEach(listener => listener(activeRequestCount));
};

export const beginNetworkActivity = () => {
	activeRequestCount += 1;
	notifyListeners();
};

export const endNetworkActivity = () => {
	activeRequestCount = Math.max(0, activeRequestCount - 1);
	notifyListeners();
};

export const subscribeNetworkActivity = (listener: ActivityListener) => {
	listeners.add(listener);
	listener(activeRequestCount);

	return () => {
		listeners.delete(listener);
	};
};

export const getActiveNetworkActivityCount = () => activeRequestCount;
